import { render, staticRenderFns } from "./BarWidget.vue?vue&type=template&id=4d4f9558&"
import script from "./BarWidget.vue?vue&type=script&lang=js&"
export * from "./BarWidget.vue?vue&type=script&lang=js&"
import style0 from "./BarWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports